import moment from "moment/moment";
import formatCurrency from "format-currency";

class PayrollController {
  constructor($rootScope, $http, toastr, $state, AuthenticationService) {
    "ngInject";
    this.name = 'customers';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$state = $state;
    this.customers = [];

    let self = this;

    this.customerColumns = [
      {
        displayName: 'Check Date',
        value: 'checkDate',
        sortable: true,
        dataType: 'date',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/payroll/"+record.id+"\" >"+record.checkDate+"</a>";
        }
      },
      {
        displayName: 'Pay Period Start',
        value: 'payPeriodStart',
        sortable: true,
        dataType: 'date'
      },
      {
        displayName: 'Pay Period End',
        value: 'payPeriodEnd',
        sortable: true,
        dataType: 'date'
      },
      {
        displayName: 'Employees Paid',
        value: 'employeesPaid',
        sortable: true,
        dataType: 'number'
      },
      {
        displayName: 'Number of Checks',
        value: 'checks',
        sortable: true,
        dataType: 'number'
      },
      {
        displayName: 'Gross Paid',
        value: 'totalGross',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.totalGross);
        }
      },
      {
        displayName: 'Net Paid',
        value: 'totalNet',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.totalNet);
        }
      },
      {
        displayName: 'Tax Witholdings',
        value: 'taxWitholdings',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return 'Federal: $' + formatCurrency(record.federalTaxWitholdings)
            + '<br/>State: $' + formatCurrency(record.stateTaxWitholdings)
            + '<br/>Local: $' + formatCurrency(record.localTaxWitholdings)
            + '<br/>Total: $' + formatCurrency(record.taxWitholdings);
        }
      },
      {
        displayName: 'Employer Responsible Social Security',
        value: 'employerResponsibleSocialSecurity',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return '$'+formatCurrency(record.employerResponsibleSocialSecurity);
        }
      },{
        displayName: 'Employer Responsible Medicare',
        value: 'employerResponsibleMedicare',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return '$'+formatCurrency(record.employerResponsibleMedicare);
        }
      },
      {
        displayName: 'Deductions',
        value: 'deductions',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return '$'+formatCurrency(record.deductions);
        }
      }

    ];



  }

}


export default PayrollController;



// WEBPACK FOOTER //
// ./client/pages/admin/payroll/payroll.controller.js